import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import InvestorAccrualScheduleReportCriteria from "./InvestorAccrualScheduleReportCriteria";
import { Misc, Model, NumberUtils } from "@singularsystems/neo-core";
import InvestorInvestmentLookup from "../../../Domain/Models/InvestorInvestments/Lookups/InvestorInvestmentLookup";
import { Layout } from "@singularsystems/neo-canvas-grid";
import AccrualScheduleHelper from "./AccrualScheduleHelper";

@NeoReport("InvestorAccrualSchedule", { category: ReportCategory.InvestorReports })
export default class InvestorAccrualScheduleReport extends Report<InvestorAccrualScheduleReportCriteria> {

    constructor(private investorInvestmentApiClient = AppService.get(DomainTypes.ApiClients.InvestorInvestment)) {
        super(InvestorAccrualScheduleReportCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.FormGroup>
                <Neo.AutoCompleteDropDown
                    bind={this.criteria.meta.investorInvestmentId}
                    bindDisplay={this.criteria.meta.investorInvestmentName}
                    itemSource={(st) => this.investorInvestmentApiClient.getInvestorInvestmentLookups(st, null, null)}
                    option={(item: Model.PlainObject<InvestorInvestmentLookup>) => <>
                        <div style={{ flexBasis: 50, flexShrink: 0 }}>{item.investorInvestmentId}</div>
                        <div style={{ flexGrow: 1 }}>{item.investorName}</div>
                        <div style={{ textAlign: "right" }}>
                            {NumberUtils.format(item.currentBalance, Misc.NumberFormat.CurrencyNoDecimals, "R")}
                        </div>
                    </>
                    }
                />
            </Neo.FormGroup>
        </div>;
    }

    public getDefaultGridLayout(criteria?: InvestorAccrualScheduleReportCriteria | undefined, propertyKey?: string | undefined) {
        return AccrualScheduleHelper.getLayout();
    }
}